var OrgMember = require('orgmember');


var OrgMemberList = Backbone.Collection.extend({
    model: OrgMember,
    initialize: function (models, options) {
        
    },
    comparator: function (a, b) {
        // Invites first
        if (a.isJoined() && !b.isJoined()) {
            return 1;
        } else if (b.isJoined() && !a.isJoined()) {
            return -1;
        // Among members, admins first
        } else if (a.isAdmin() && !b.isAdmin()) {
            return -1;
        } else if (b.isAdmin() && !a.isAdmin()) {
            return 1;
        // Among members, first joined first
        } else if (a.get('join_time') > b.get('join_time')) {
            return -1;
        } else if (a.get('join_time') < b.get('join_time')) {
            return 1;
        // Among invites, first invited first
        } else if (a.get('invite_time') > b.get('invite_time')) {
            return -1;
        } else if (a.get('invite_time') < b.get('invite_time')) {
            return 1;
        } else {
            return 0;
        }
    }
});


module.exports = OrgMemberList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/orgmemberlist.js
// module id = L46s
// module chunks = 1